const VISITOR_KEY = 'fgq_anonymous_visitor'
const SESSION_KEY = 'fgq_visit_session'

function createId() {
  if (window.crypto && typeof window.crypto.randomUUID === 'function') {
    return window.crypto.randomUUID()
  }
  return `${Date.now().toString(36)}_${Math.random().toString(36).slice(2)}_${Math.random().toString(36).slice(2)}`
}

function readOrCreate(storage, key) {
  try {
    const value = storage.getItem(key)
    if (value) return value
    const created = createId()
    storage.setItem(key, created)
    return created
  } catch (error) {
    return createId()
  }
}

export function getTrackingContext(language = 'en') {
  const query = new URLSearchParams(window.location.search)
  return {
    visitor_id: readOrCreate(window.localStorage, VISITOR_KEY),
    session_id: readOrCreate(window.sessionStorage, SESSION_KEY),
    language,
    path: `${window.location.pathname}${window.location.search}`.slice(0, 255),
    title: document.title.slice(0, 255),
    referrer: document.referrer.slice(0, 500),
    screen_size: `${window.screen.width}x${window.screen.height}`,
    utm_source: (query.get('utm_source') || '').slice(0, 100),
    utm_medium: (query.get('utm_medium') || '').slice(0, 100),
    utm_campaign: (query.get('utm_campaign') || '').slice(0, 100)
  }
}

export function trackPageView(api, language = 'en') {
  if (!api || typeof api.trackVisitor !== 'function') return
  api.trackVisitor(getTrackingContext(language)).catch(() => {})
}
